var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23242 5L9.66821 4.75487L9.52485 4.5H9.23242V5ZM9.23242 15V15.5H9.52485L9.66821 15.2451L9.23242 15ZM12.0449 10.5H18.2949V9.5H12.0449V10.5ZM5.16992 5.5H9.23242V4.5H5.16992V5.5ZM8.79663 5.24513L11.6091 10.2451L12.4807 9.75487L9.66821 4.75487L8.79663 5.24513ZM11.6091 9.75487L8.79663 14.7549L9.66821 15.2451L12.4807 10.2451L11.6091 9.75487ZM9.23242 14.5H5.16992V15.5H9.23242V14.5Z",
    fill: "#1D6295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1694 6.7002L18.4693 10L15.1694 13.2999",
    stroke: "#1D6295",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombine);
export default __webpack_public_path__ + "static/media/combine.79216943751a162c6a0e5117aed4bde9.svg";
export { ForwardRef as ReactComponent };